import type { User } from '@/types/auth';
import { RoleEnum } from '@/types/auth/roles';
import { hasRevokedAccess } from './revokedAccess';
import { hasPermission, Permission } from './permissions';

export const hasExceptionalTraderTelegramCreateAccess = (
  user: User | null | undefined,
): boolean => hasPermission(user, Permission.TRADER_TELEGRAM_CHATS_CREATE);

export const canCreateTraderTelegramChat = (user: User | null | undefined): boolean => Boolean(
  user && !hasRevokedAccess(user) && (
    user.is_superuser || user.role === RoleEnum.ADMIN || user.role === RoleEnum.CLIENT_MANAGER
    || hasExceptionalTraderTelegramCreateAccess(user)
    || hasPermission(user, Permission.TRADERS_MANAGE)
  ),
);

export const canEditTraderTelegramChat = (user: User | null | undefined): boolean => Boolean(
  user && !hasRevokedAccess(user) && (
    user.is_superuser || user.role === RoleEnum.ADMIN || user.role === RoleEnum.CLIENT_MANAGER
    || hasPermission(user, Permission.TRADERS_MANAGE)
  ),
);
